import React, { useEffect, useState } from 'react';
import BusinessPage from "./views/BusinessPage";
import Check from "./views/Check";
import MManger from "./views/MManger";
import PlansAndAddons from "./views/PlansAndAddons";
import Staff from "./views/Staff";
import Transactions from "./views/Transactions";

import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import "../src/motos_lp/assets/css/materialdesignicons.min.css";
import "../src/motos_lp/assets/scss/themes.scss";
import "./components/css/Responsive.css";
import "./components/css/font.css";
import "./components/css/home.css";
import "./components/css/mdb.min.css";
import "./landingpage/styles/global.css";
// import './whatsapp/styles/whatsapp-registration.css'
// import './whatsapp/styles/whatsapp-templates.css'
// import './whatsapp/styles/whatsapp-create-template.css'
// import './whatsapp/styles/WhatsAppMessagess.css';
// import './whatsapp/styles/WhatsAppCampaign.css'
// import './whatsapp/styles/CreateCampaign.css'
import ErrorBoundary from "./ErrorBoundary";
import Reports from "./components/Reports";
import Privacy from "./components/privacy";
import Terms from "./components/terms";
import VEmails from "./components/verifiedemail";
import Pricing from "./motos_lp/component/Pricing";
import ResetPassword from './motos_lp/pages/auth/reset-password';
import Comingsoon from './motos_lp/pages/comingsoon';
import Error from './motos_lp/pages/error';
import Maintenance from './motos_lp/pages/maintenance';
import Saas from './motos_lp/pages/saas';
import FileNotFound from "./views/404";
import ActiveMembers from "./views/ActiveMembers";
import AttendanceList from "./views/AttendanceList";
import BusinessInfo from "./views/BusinessInfo";
import ComingSoon from "./views/ComingSoon";
import CreateAddon from "./views/CreateAddon";
import CreateSlot from "./views/CreateSlot";
// import CreateSlotView from "./views/CreateSlotView";
import Dashboard from "./views/Dashboard";
import DigitalWaiver from "./views/DigitalWaiver";
import WaiverVerifyLinkPage from "./views/WaiverVerifyLinkPage";
import EmailTemplateView from "./views/EmailTemplateView";
import HomePage from "./views/HomePage";
import Login from "./views/Login";
import LoginSignup from "./views/LoginSignup";
import MDetails from "./views/MDetails";
import OTPValidation from "./views/OTP_Validation";
import Payments from "./views/Payments";
import ReceiptPrint from "./views/ReicptPrint";
import SMSRemainder from "./views/SMSRemainder";
import Settings from "./views/Settings";
import Checkinreport from "./views/checkinreport";
import CreatePlan from "./views/createPlan";
import Eventtracker from "./views/eventstracker";
import UploadLogo from "./views/uploadLogo";
import EmailTempletes from "./views/EmailTempletes";
import PageError from "./views/PageError";
import MessageSettings from "./views/MessageSettings";
// import DefaultTempletes from "./views/DefaultTempleteslazzy";
import EditMessage from "./views/EditMessage";
import PaymentLinkPage from "./components/CompressPaymentURL";
import RedirectScreen from "./views/RedirectScreen";
import BussinessReport from "./views/accountsReports";
import AccountsEventsReports from "./views/accountsEventsReports";
import BillingSubscriptionPlan from "./views/BillingSubscriptionPlan";
import Addons from "./components/Addons";
import ResetPasswords from "./views/ResetPasswords";
import ConfirmPassword from "./views/ConfirmPassword"
import Feature from './motos_lp/component/Feature';
import Contact from './motos_lp/component/Contact';
import Leads from './motos_lp/pages/leads';
import Offers from './motos_lp/pages/offers';
import ClassDashboard from "./views/Classes/ClassDashboard";
import Classes from "./views/Classes/Classes";
import ClassSchedules from "./views/Classes/ClassSchedules";
// import ClassesBooking from "./views/Classes/ClassesBooking";
import ClassesBooking from "./views/Classes/newClassesBooking";
import ClassUsers from "./views/Classes/ClassUsers";
import CancelationPolicy from "./views/Classes/CancelationPolicy";
// import SchudeleCalender from './views/Classes/SchudeleCalender';
import SchudeleCalender from './views/Classes/newUserBooking';
// import QRCheckin from './views/QRCheckin';
// import Segmentation from './views/Segmentation';
// import SegmentationSettings from './views/SegmentationSettings';
import ScheduleInvoice from './views/Classes/ScheduleInvoice';
import ClassBusinessInfo from './views/Classes/ClassBusinessInfo';

import QRCheckin from './views/QRCheckin';
import QRScanner from './QRScanner';
import QRLogin from './views/QRLogin';
import BillingSubscriptionMagmntPlan from './views/BillingSubscriptionmngtPlans';
import GoogleMapLocation from './views/GoogleMapComponent';
import EditLocationPopup from './views/EditLocationPopup';


import LandingPage from './landingpage/pages/LandingPage';
import ProductsLanding from './landingpage/pages/ProductsLanding';
import yogaData from './landingpage/data/yogaData';
import pilatesData from './landingpage/data/PilatesData';
import danceData from './landingpage/data/DanceData';
import RequestDemo from './landingpage/pages/RequestDemo';
import martialArtsData from './landingpage/data/MartialArtsData';
import swimmingPoolData from './landingpage/data/SwimmingPoolData';
import PricingNew from './landingpage/pages/PricingNew';
import GymProducts from './landingpage/pages/GymProducts';
import ScheduleaDemo from './landingpage/pages/ScheduleaDemo';
import MemberManagementLanding from './landingpage/pages/MemberManagementLanding';
import LeadManagementLanding from './landingpage/pages/LeadManagementLanding';
import ClasssLanding from './landingpage/pages/ClasssLanding';
import ClassesLogin from './views/Classes/ClassesLogin';
import ClassesSignup from './views/Classes/ClassesSignup';
import ClassesLandingPage from './views/Classes/ClassesLandingPage';
// import SegmentCampaign from './views/segment&Campaign';
// import EditSegment from './views/editSegment';
import ClassTransaction from './views/Classes/classTransaction';
import CampaignAnalytics from './views/campaignAnalytics';
import MyCalendar from './views/Classes/newClassesBooking';
import ClassSettings from './views/Classes/classSettings';
import FreeSignupForm from './views/FreeSignup';
import gymData from './landingpage/data/gymData';
import Cancellation from './components/generalCancellationPolicy';
import { getBussinessInfobyUrl } from './services/classApiServices';
// import Loader from "../components/Loader";
import Loader from "./components/Loader.js";
// import LandingpageTemplateView from "./views/LandingpageTemplateView";
import NewLeads from './motos_lp/pages/leadspage';
import GymHome from './gymhomepage/pages/GymHome';
import GymPageEditor from './gymhomepage/pages/EditGymHome';
import "./gymhomepage/styles/gymhomepage.css";
import GymHerosection from './gymhomepage/components/herosection';
import PlanCard from './gymhomepage/components/PlanCard';
import GymContact from './gymhomepage/components/ContactForm';
import GymTemplate from './views/gymTemplate';
import ClassEventTracker from './views/Classes/ClassEventTracker';
import MemberDashboard from './memberportal/pages/MemberDashboard';
import AvailableSessions from './memberportal/pages/AvailableSessions';
import MembershipPlans from './memberportal/pages/MembershipPlans';
import ViewCart from './memberportal/components/ViewCart';
// import { CartProvider } from './context/CartContext';
import { CartProvider } from './memberportal/components/CartContext';
import MemberBillingPage from './memberportal/components/MemberBillingpage';
import MemberTransactions from './memberportal/pages/MemberTransactions';
import MemberProfile from './memberportal/pages/MemberProfile';
import MemberCheckins from './memberportal/components/MemberCheckins';
import MemberLogin from './memberportal/pages/MemberLogin';
import MemberDuepayment from './memberportal/components/MemberDuepayment';
import Announcements from './components/Announcements';
import MemberSignup from './memberportal/pages/MemberSignup';
import Booksessions from './memberportal/components/Booksessions';
import MemberWaiver from './memberportal/components/MemberWaiver';
import ClassTransWaiver from './components/class/ClassTranWavier';
import QrWaiverPage from './QrWaiverPage';
import { useAnalytics } from './hooks/useAnalytics';
import { initGA } from './utils/gtag';

import { getRoleAccess } from './services/apiServices';
import { AccessProvider } from './context/AccessContext';
import ClassBookingPage from './views/ClassDetails';
import QRCodeGenerator from './views/QRCodeGenerator';
import WhatsAppSettings from './whatsapp/pages/Settings';
import WhatsAppConnect from './whatsapp/pages/Connect';
import WhatsAppSignup from './whatsapp/pages/WhatsAppSignup';
import CallbackSuccess from './whatsapp/pages/CallbackSuccess';
// import WhatsAppDashboard from './whatsapp/pages/Dashboard';
import WhatsAppTemplates from './whatsapp/pages/Templates';
import CreateWhatsAppTemplate from './whatsapp/components/CreateTemplate';
// import CreateCampaign from './whatsapp/components/CreateCampaign';
import WhatsAppMessages from './whatsapp/pages/WhatsAppMessages';
// import WhatsappCampaignDetails from './whatsapp/pages/WhatsappCampaignDetails';
import { SocketProvider } from './whatsapp/contexts/SocketContext';
import { VerifyPage } from './views/VerifyPage';
import LeadsList from './whatsapp/pages/LeadsList';
import LeadDetails from './whatsapp/pages/LeadDetails';
// import WhatsappCampaign from './whatsapp/pages/WhatsappCampaign';
// import GymWebsite from './motos_lp/pages/gymwebsite';

function setToken(userToken) {
  try {
    localStorage.setItem("token", userToken);
  } catch (e) {
    console.log("Error while creating session.. " + e);
  }
}

function getToken() {
  try {
    const tokenString = localStorage.getItem("token");
    console.log(tokenString);
    const userToken = JSON.parse(tokenString);
    return userToken;
  } catch (e) {
    console.log("error :::::: " + e);
    return;
  }
}
let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;

function PrivateRoute() {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

const PageViewTracker = () => {
  const location = useLocation();
  const { useTrackPageView } = useAnalytics();

  useTrackPageView(); // This will track page views on route change

  return null;
};

function App() {

  console.log("App component rendered");
  const [bussinessinfo, setbusinessinfo] = useState(null)
  const [isLoading, setIsLoading] = useState(true);
  // const hostname = "demo.easymembr.com";
  const hostname = window.location.hostname;
  let subdomain = "";
  // console.log(hostname, 'hostname');
  // 
  if (hostname.endsWith('easymembr.com') || hostname.endsWith('zencruz.com')) {
    const parts = hostname.split('.');
    if (parts.length === 3 && parts[0] !== 'www' && parts[0] !== "app" && parts[0] !== "beta" && parts[0] !== "portal") {
      subdomain = parts[0];
    }
  }


  console.log('Subdomain:', subdomain);

  useEffect(() => {
    const fetchBusiness = async () => {
      try {
        const identifier = subdomain;
        const type = 'subdomain'
        if (!subdomain) {
          setIsLoading(false);
          return;
        }
        const response = await getBussinessInfobyUrl(identifier, type);

        if (!response || response === "false") {
          setbusinessinfo(null);
        } else {
          const businessData = await response.json();
          setbusinessinfo(businessData);
        }
      } catch (error) {
        console.error("Failed to fetch business info:", error);
        setbusinessinfo(null);
      } finally {
        setIsLoading(false);
      }
    };

    // if (plansInfo === null || (plansInfo != null && !plansInfo?.planFeature?.pos)) {
    fetchBusiness();
    // } else if (subdomain != "") {
    //   const originalText = hostname;
    //   const updatedText = originalText.replace((subdomain + "/"), "");
    //   window.location.href = updatedText;
    // } else {
    //   fetchBusiness();
    // }
  }, [subdomain]);


  console.log("------------------app----------------")
  const token = getToken();
  console.log("Token ... " + token);
  if (!token) {
    // return <Login setToken={setToken} />;
  }


  useEffect(() => {
    initGA();
  }, []);

  if (isLoading) {
    return <Loader />
  }
  console.log(bussinessinfo !== null, '9999999999');
  return (
    <ErrorBoundary>
      <AccessProvider>
        <CartProvider>
          <SocketProvider>
            <BrowserRouter>
              <PageViewTracker />
              <Routes>
                <Route
                  path="/"
                  element={bussinessinfo !== null ? <GymHome /> : <Login setToken={setToken} />}
                />
                <Route path="/*" element={<FileNotFound />} />
                {/* <Route path="/" index element={<Login setToken={setToken} />} /> */}
                <Route path="/login" index element={<Login setToken={setToken} />} />
                <Route path="/signup" index element={<LoginSignup setToken={setToken} />} />
                <Route path="/home" index element={<HomePage />} />
                <Route element={<PrivateRoute />}>
                  <Route path="/transactions" element={<Transactions />} />
                  <Route path="/payments" element={<Payments />} />
                  <Route path="/printreceitpt" element={<ReceiptPrint />} />
                  <Route path="/businfo" element={<BusinessPage />} />
                  <Route path="/addplans" element={<CreatePlan />} />
                  <Route path="/addaddons" element={<CreateAddon />} />
                  <Route path="/addslots" element={<CreateSlot />} />
                  <Route path="/bInfo" element={<BusinessInfo />} />
                  <Route path="/mmanager" element={<MManger />} />
                  <Route path="/mailremainder" element={<SMSRemainder />} />
                  <Route path="/adminremainder" element={<ComingSoon />} />
                  {(plansInfo === null || (plansInfo.feature && plansInfo.feature.membercheckin)) &&
                    <Route path="/checkin" element={<Check />} />}
                  <Route path="/staff" element={<Staff />} />
                  <Route path="/plansandaddons" element={<PlansAndAddons />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/plans" element={<PlansAndAddons />} />
                  {(plansInfo === null || (plansInfo.feature && plansInfo.feature.dashboard)) &&
                    <Route path="/dashboard" element={<Dashboard />} />}
                  <Route path="/mdetails" element={<MDetails />} />
                  <Route path="/attendance" element={<AttendanceList />} />
                  <Route path="/settingview" element={<Settings viewmode="1" />} />
                  <Route path="/activemembers" element={<ActiveMembers />} />
                  <Route path="/verifyemail" element={<VEmails />} />
                  <Route path="/logEvent" element={<Eventtracker />} />
                  <Route path="/saas" element={<Saas />} />
                  <Route path="/checkreport" element={<Checkinreport />} />
                  <Route path="/report" element={<Reports />} />
                  <Route path="/report/ga_accounts" element={<BussinessReport />} />
                  <Route path="/report/ga_accountssessons" element={<AccountsEventsReports />} />
                  <Route path="/upoadlogo" element={<UploadLogo />} />
                  <Route path="/emailTemple" element={<EmailTempletes />} />
                  <Route path="/emailTemplateView" element={<EmailTemplateView />} />
                  <Route path="/messageSettings" element={<MessageSettings />} />
                  <Route path="/smsremainder" element={<SMSRemainder />} />
                  <Route path="/editmessage" element={<EditMessage />} />
                  <Route path="/billingsubscriptionplan" element={<BillingSubscriptionPlan />} />
                  <Route path="/billingmanagementplans" element={<BillingSubscriptionMagmntPlan />} />
                  <Route path="/classdashboard" element={<ClassDashboard />} />
                  <Route path="/classes" element={<Classes />} />
                  <Route path="/classschedules" element={<ClassSchedules />} />
                  <Route path="/classesbooking" element={<ClassesBooking />} />
                  <Route path="/classesbusiness" element={<ClassBusinessInfo />} />
                  <Route path="/classusers" element={<ClassUsers />} />
                  <Route path="/cancelationpolicy" element={<CancelationPolicy />} />
                  <Route path="/scheduleinvoice" element={<ScheduleInvoice />} />
                  <Route path="/classsettings" element={<ClassSettings />} />
                  <Route path="/classlogevent" element={<ClassEventTracker />} />
                  <Route path="/editgymhome" element={<GymPageEditor />} />
                  <Route path="/gymtemplate" element={<GymTemplate />} />
                  <Route path="/announcements" element={<Announcements />} />
                  <Route path="/GoogleMapLocation" element={<GoogleMapLocation />} />
                  <Route path="/EditLocationPopup" element={<EditLocationPopup />} />
                  <Route path="whatsapp/settings" element={<WhatsAppSettings />} />
                  <Route path="whatsapp/connect" element={<WhatsAppConnect />} />
                  <Route path="whatsapp/templates" element={<WhatsAppTemplates />} />
                  <Route path="whatsapp/templates/create" element={<CreateWhatsAppTemplate />} />
                  <Route path="whatsapp/messages" element={<WhatsAppMessages />} />
                  <Route path="/whatsapp/leads" element={<LeadsList />} />
                  <Route path="/whatsapp/leads/:id" element={<LeadDetails />} />
                  <Route path="/qrcodegenerator" element={<QRCodeGenerator />} />
                </Route>
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/features" element={<Feature />} />
                <Route path="/contact" element={<Contact />} />
                {/* <Route path="/landingpagetemplateview" element={<LandingpageTemplateView />} /> */}

                <Route path="/maintenance" element={<Maintenance />} />
                <Route path="/error" element={<Error />} />
                <Route path="/comingsoon" element={<Comingsoon />} />
                <Route path="/auth-reset-password" element={<ResetPassword />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                {/* <Route path="/faqs" element={<MainDashBoard />} /> */}
                <Route path="/cancellation_policy" element={<Cancellation />} />
                <Route path="/OtpValidation" element={<OTPValidation />} />
                <Route path="/waiver" element={<DigitalWaiver />} />
                <Route path="/waiver/verify/link" element={<WaiverVerifyLinkPage />} />
                <Route path="/pageerror" element={<PageError />} />
                <Route path="/p" element={<PaymentLinkPage />} />
                <Route path="/paymentredirect" element={<RedirectScreen />} />
                <Route path="/getresetPassword" element={<ResetPasswords />} />
                <Route path="/login/restpassword/:id" element={<ConfirmPassword />} />
                <Route path="/landingpage" element={<Leads />} />
                <Route path="/plan-offers" element={<NewLeads />} />
                <Route path="/offerspage" element={<Offers />} />
                <Route path="/privacypolicy" element={<Privacy />} />
                <Route path="/termsandconditions" element={<Terms />} />
                <Route path="/booking" element={<AvailableSessions />} />
                <Route path="/classlogin" element={<ClassesLogin setToken={setToken} />} />
                <Route path='/classlandingpage' element={<ClassesLandingPage />} />
                <Route path="/classsignup" element={<ClassesSignup setToken={setToken} />} />
                <Route path="/classtransaction" element={<ClassTransaction />} />
                <Route path='/calender' element={<ClassesBooking />} />
                <Route path="/qrcheckin" element={<QRCheckin />} />
                <Route path="/qrscanner" element={<QRScanner />} />
                <Route path="/qrlogin" element={<QRLogin />} />
                <Route path="/contactus" element={<RequestDemo />} />
                <Route path="/yogastudio" element={<ProductsLanding {...yogaData} />} />
                <Route path="/pilatesstudio" element={<ProductsLanding {...pilatesData} />} />
                <Route path="/dancestudio" element={<ProductsLanding {...danceData} />} />
                <Route path="/martialstudio" element={<ProductsLanding {...martialArtsData} />} />
                <Route path="/swimmingstudio" element={<ProductsLanding {...swimmingPoolData} />} />
                <Route path="/gymstudio" element={<ProductsLanding {...gymData} />} />
                <Route path="/commercials" element={<PricingNew />} />
                <Route path="/products" element={<GymProducts />} />
                <Route path="/bookademo" element={<ScheduleaDemo />} />
                <Route path="/easymembr" element={<MemberManagementLanding />} />
                <Route path="/easylead" element={<LeadManagementLanding />} />
                <Route path="/easybook" element={<ClasssLanding />} />
                <Route path="/freesignup" element={<FreeSignupForm setToken={setToken} />} />
                <Route path='/gymhome' element={<GymHome />} />
                <Route path='/gymherosection' element={<GymHerosection />} />
                <Route path='/plancard' element={<PlanCard />} />
                <Route path='/gymcontact' element={<GymContact />} />
                <Route path='/memberdashboard' element={<MemberDashboard />} />
                <Route path='/availablesessions' element={<AvailableSessions />} />
                <Route path='/membershipplans' element={<MembershipPlans />} />
                <Route path='/viewcart' element={<ViewCart />} />
                <Route path="/memberbilling" element={<MemberBillingPage />} />
                <Route path="/membertransaction" element={<MemberTransactions />} />
                <Route path="/memberprofile" element={<MemberProfile />} />
                <Route path="/membercheckins" element={<MemberCheckins />} />
                <Route path="/memberlogin" element={<MemberLogin />} />
                <Route path="/memberduepayment" element={<MemberDuepayment />} />
                <Route path="/membersignup" element={<MemberSignup />} />
                <Route path="/booksessions" element={<Booksessions />} />
                <Route path='/memberwaiver' element={<MemberWaiver />} />
                <Route path="/classtranswaiver" element={<ClassTransWaiver />} />
                <Route path="/qrwaiver" element={<QrWaiverPage />} />
                <Route path="/class" element={<ClassBookingPage />} />
                <Route path="/whatsapp-connect" element={<WhatsAppSignup />} />
                <Route path="/whatsapp/callback" element={<CallbackSuccess />} />
                {/* <Route path="whatsapp/campaigndetails/:id" element={<WhatsappCampaignDetails />} /> */}

                <Route path="Verify/email" element={<VerifyPage />} />

                <Route path="verify-email" element={<VerifyPage />} />
                {/* <Route path="Verify/email" element={<VerifyPage />} /> */}
              </Routes>
            </BrowserRouter>
          </SocketProvider>
        </CartProvider>
      </AccessProvider>
    </ErrorBoundary >
  );
}

export default App;